import { SphereBufferGeometry } from "three"
import * as THREE from "three"

export default class Ball {
    constructor(scene) {
        this.scene = scene
        const geo = new SphereBufferGeometry(1.5, 32, 32)
        const mat = new THREE.MeshBasicMaterial({ color: 0xff2222 })
        this.mesh = new THREE.Mesh(geo, mat)

        this.mesh.position.set(0, 0, 10)
    
        this.scene.add(this.mesh)
    }

    update() {

    }
}

// const _instance = new Example()
// export default _instance